import throttle from 'lodash.throttle';

class InfiniScroller {
  constructor(opts) {
    this.scrollPercentageMet = this.scrollPercentageMet.bind(this);
    this.performOnScroll = this.performOnScroll.bind(this);
    this.scrollPercentage = opts.scrollPercentage || 0.9;
    this.throttleAmount = opts.throttle || 95;
    this.onScrollCb = opts.onScroll;
  }

  scrollPercentageMet() {
    const { body, documentElement } = document;
    const supportPageOffset = window.pageXOffset !== undefined;
    const CSS1Compat =
      (document.compatMode || '') === 'CSS1Compat'
        ? document.documentElement.scrollTop
        : document.body.scrollTop;
    const scrollTop = supportPageOffset ? window.pageYOffset : CSS1Compat;
    const documentHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      documentElement.clientHeight,
      documentElement.scrollHeight,
      documentElement.offsetHeight,
    );
    const bodyHeight = documentHeight - window.innerHeight;

    return scrollTop / bodyHeight > this.scrollPercentage;
  }

  performOnScroll() {
    if (this.scrollPercentageMet()) {
      this.onScrollCb();
    }
  }

  setOnScroll() {
    if (!this.onScrollCb) {
      throw new Error(
        '`onScroll` parameter not established in constructor. `onScroll` is required.',
      );
    }
    window.addEventListener(
      'scroll',
      throttle(this.performOnScroll, this.throttleAmount),
      false,
    );
  }

  removeOnScroll() {
    window.removeEventListener(
      'scroll',
      throttle(this.performOnScroll, this.throttleAmount),
      false,
    );
  }
}

export default InfiniScroller;
